import { render, staticRenderFns } from "./overduePaymentAmount.vue?vue&type=template&id=8437543c"
import script from "./overduePaymentAmount.vue?vue&type=script&lang=js"
export * from "./overduePaymentAmount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports